import { render } from "./SurveyForm.vue?vue&type=template&id=f085f78a&scoped=true"
import script from "./SurveyForm.vue?vue&type=script&lang=js"
export * from "./SurveyForm.vue?vue&type=script&lang=js"

import "./SurveyForm.vue?vue&type=style&index=0&id=f085f78a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f085f78a"]])

export default __exports__